import { useEffect } from "preact/hooks"

import { baixarAnexo } from "../lib/anexo"
import { IconClose, IconDownload } from "./icons"

type Props = {
  url: string
  mime: string | null
  onFechar: () => void
}

/**
 * A imagem ampliada, ocupando a janela do chat inteira.
 *
 * Fica DENTRO do widget de propósito: o iframe não alcança a página do cliente,
 * então um visor "de tela cheia" de verdade não existe daqui. No celular, onde a
 * janela já ocupa a tela, isto é tela cheia na prática; no desktop, é a imagem
 * inteira sem o recorte da bolha — que é o que faltava.
 */
export function Visor({ url, mime, onFechar }: Props) {
  // Esc fecha, e o `keydown` é do documento porque o foco pode estar no botão,
  // na imagem ou em lugar nenhum.
  useEffect(() => {
    const aoTeclar = (evento: KeyboardEvent) => {
      if (evento.key === "Escape") {
        evento.stopPropagation()
        onFechar()
      }
    }
    document.addEventListener("keydown", aoTeclar)
    return () => document.removeEventListener("keydown", aoTeclar)
  }, [onFechar])

  return (
    <div
      class="visor"
      role="dialog"
      aria-modal="true"
      aria-label="Imagem ampliada"
      onClick={onFechar}
    >
      <div class="visor-barra" onClick={(evento) => evento.stopPropagation()}>
        <button
          type="button"
          class="visor-btn"
          onClick={() => void baixarAnexo(url, mime)}
        >
          <IconDownload />
          Baixar
        </button>
        <button
          type="button"
          class="visor-btn"
          onClick={onFechar}
          aria-label="Fechar imagem ampliada"
        >
          <IconClose />
        </button>
      </div>
      {/* O clique na imagem NÃO fecha: dar zoom e errar o alvo fecharia o visor
          no meio da olhada. Fecha no fundo, no botão ou no Esc. */}
      <img
        class="visor-img"
        src={url}
        alt="Imagem da conversa, ampliada"
        onClick={(evento) => evento.stopPropagation()}
      />
    </div>
  )
}
